const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'actions/get-media-locations-for-selected-variant.action';
            binding.dataActions[actionPath] = require('partner/actions/get-media-locations-for-selected-variant.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-price-for-selected-variant.action';
            binding.dataActions[actionPath] = require('partner/actions/get-price-for-selected-variant.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-store-location-centiro.action';
            binding.dataActions[actionPath] = require('partner/actions/get-store-location-centiro.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/store-centiro-location.action';
            binding.dataActions[actionPath] = require('partner/actions/store-centiro-location.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/update-b2c-identity.action';
            binding.dataActions[actionPath] = require('partner/actions/update-b2c-identity.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/ext-category-page-summary/ext-category-page-summary.action';
            binding.dataActions[actionPath] = require('partner/modules/ext-category-page-summary/ext-category-page-summary.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/ext-product-page-summary/ext-product-page-summary.action';
            binding.dataActions[actionPath] = require('partner/modules/ext-product-page-summary/ext-product-page-summary.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };